// Display name for a searchroom: its own label, else derived from its items,
// else a neutral fallback. Mirrors the old app's behavior where empty-labeled
// rooms show their first item (with a "+N" for the rest).
export function searchroomLabel(room) {
  const own = room?.label?.trim()
  if (own) return own

  const items = room?.items || []
  const first = items.find((item) => item?.label)?.label
  if (first) return items.length > 1 ? `${first} +${items.length - 1}` : first

  return 'Untitled'
}
